import React from 'react';
import cn from 'classnames';
import { IBaseElementProps } from 'tbk-components/src/components/BasicElement';

export interface ICareersInnerInfoTerm {
	label: string;
	value: string;
}
export interface ICareersInnerInfoProps extends IBaseElementProps {
	/**
	 * Terms to appear in the list
	 */
	terms?: ICareersInnerInfoTerm[]
}

/**
 * Calian ESG Component
 * @icon text
 * @block
 */
const CareersInnerInfo: React.FC<ICareersInnerInfoProps> = ({
	id,
	className,
	classNames = [],
	terms = [],
}) => (
	<div
		id={id}
		className={className || cn('calian-careers-inner-info d-flex flex-row', ...classNames)}
	>
		{terms.map(({ label, value },index) => <div className="d-flex flex-column me-10" key={index}>
			<div className="calian-careers-inner-info__label">{label}</div>
			<div className="calian-careers-inner-info__value" dangerouslySetInnerHTML={{ __html: value }}></div>
		</div>)}
	</div>
);

export default CareersInnerInfo;
